import React from "react";

const Badge = ({ text }) => {
  return (
    <div
      className="bg-primeColor min-w-[90px] h-[35px] text-white flex justify-center items-center text-base font-semibold hover:bg-black transition-all duration-300 cursor-pointer px-3 rounded-md"
      aria-label={`${text} - Premium Quality Badge`}
      data-seo-keywords="premium product badge, export quality label, verified supplier, certified goods, RK Global Trader"
      title={`${text} • Verified & Trusted Quality`}
    >
      {text}
    </div>
  );
};

export default Badge;
